import React from "react";
import { Button, Loading } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import TransactionCodeForm from "./TransactionCodeForm";
import { useTransactionCode } from "../../hooks/Provider";

const TransactionCodeFormModal = () => {
  const {
    onSubmit,
    modalConfig,
    detail,
    setModalConfig,
    methods,
  } = useTransactionCode();
  const { formState: { isValid, errors } } = methods;
  return (
    <Modal
      isOpen={modalConfig?.type === "CREATE" || modalConfig?.type === "UPDATE"}
      setOpen={() => setModalConfig(undefined)}
      title={`${modalConfig?.type === "UPDATE" ? "Edit data" : "Tambah data"} - transaction code`}
      body={
        (modalConfig?.type === "CREATE" || (modalConfig?.type === "UPDATE" && detail))
          ? <TransactionCodeForm />
          : <Loading variant="circular" />
      }
      footer={
        <div className="action-container">
          <Button
            variant="text"
            type="button"
            onClick={() => setModalConfig(undefined)}
          >
            Batal
          </Button>
          <Button
            onClick={onSubmit}
            disabled={!(
              (modalConfig?.type === "CREATE"
                || (modalConfig?.type === "UPDATE" && detail)
              )
              && isValid
            )}
          >
            Simpan
          </Button>
        </div>
      }
    />
  );
};

export default TransactionCodeFormModal;
